import styled from '@emotion/styled';
import { Table, TableCell, TableHeaderCell, TableRow } from 'react-magma-dom';
import { COLORS } from '../../constants';

export const StyledTable = styled(Table)<{
  isTowardsAtBeyond?: boolean;
}>`
  margin: 10px 0;

  ${({ isTowardsAtBeyond }) =>
    isTowardsAtBeyond &&
    `
      tr:first-of-type td {
        padding: 21px;
      }

      td:first-of-type {
        background-color: ${COLORS.yellowLight};
      }

      td {
        background-color: ${COLORS.orangeLight};
        padding: 24px;
      }

      td:last-child {
        background-color: ${COLORS.redLight};
      }
    `}
`;

export const StyledTableRow = styled(TableRow)`
  border: 1px solid ${COLORS.veryLightPink};
`;

export const StyledTableHeaderCell = styled(TableHeaderCell)<{
  colSpan?: number;
}>`
  background: ${COLORS.white};
  color: ${COLORS.blackOlive};
  padding: 20px;
  border-bottom: 1px solid ${COLORS.veryLightPink};

  p {
    margin: 0;
  }
`;

export const StyledTableCell = styled(TableCell)<{
  width?: number;
}>`
  border: 1px solid ${COLORS.veryLightPink} !important;
  font-weight: normal;
  color: ${COLORS.blackOlive};
  padding: 20px;

  ${({ width }) =>
    width &&
    `
      width: ${width}%!important;
    `}
`;
